<template>
  <div class="text-[1rem] md:text-[1.5rem] lg:text-[1.625rem]">
    <div
      class="bg-[#554638] rounded-t-[16px] flex flex-row text-white font-[700] py-[12px] md:py-[14px] lg:py-[16px] px-[16px] md:px-[18px] lg:px-[20px]"
    >
      <p class="w-[25%]">Month</p>
      <p class="flex-1">Transaction Date</p>
      <p class="w-[25%]">Status</p>
    </div>
    <div
      class="bg-white rounded-b-[16px] flex flex-col gap-[16px] md:gap-[18px] lg:gap-[20px] p-[16px] md:p-[18px] lg:p-[20px]"
    >
      <div
        v-for="(month, index) in months"
        :key="index"
        class="flex flex-row font-[400] text-gray-900"
      >
        <p class="w-[25%]">
          {{ month }}
        </p>
        <div
          v-if="transactionDates[month] && transactionDates[month].length"
          class="flex-1 flex flex-col"
        >
          <div
            v-for="(transaction, index) in transactionDates[month]"
            :key="index"
            class="flex-1 flex flex-row"
            :class="{ 'mt-[16px]': index > 0 }"
          >
            <p class="flex-1">{{ transaction.transaction_date }}</p>
            <p class="w-[33%]">🍏</p>
          </div>
        </div>
        <div v-else class="flex-1 flex flex-row">
          <p class="flex-1">-</p>
          <p class="text-[#191817] w-[33%]">-</p>
        </div>
        <!--        <p v-if="transactionDates[index] === '-'" class="w-[25%]">&nbsp-</p>-->
        <!--        <p v-else class="text-[#191817] w-[25%]">🍏</p>-->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    };
  },
  props: {
    transactionDates: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped>
* {
  font-family: 'Inter';
}
</style>
